module.exports = __webpack_public_path__ + "static/media/Second-Title.08a5ffeb.png";